import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111814] text-[#D7D2C6] py-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-9 h-9 flex items-center justify-center bg-[#C5A059] text-[#111814] font-serif text-xl">
              R
            </span>
            <div>
              <div className="font-serif text-lg text-[#FDFBF7]">
                Roopesh Kumar
              </div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#C5A059]">
                & Associates
              </div>
            </div>
          </div>
          <p className="text-sm leading-relaxed max-w-xs text-[#A8B0A9]">
            Chartered Accountants based in Chittoor, serving clients across
            Bengaluru, Chennai, Hyderabad and PAN-India.
          </p>
        </div>

        <div>
          <div className="overline text-[#C5A059] mb-4">Office</div>
          <address className="not-italic text-sm leading-relaxed text-[#D7D2C6]">
            3-220/1, Near Sri Rama Bajana Mandir,
            <br />
            Brahmin Street, Greamspet,
            <br />
            Chittoor, AP — 517002
          </address>
        </div>

        <div>
          <div className="overline text-[#C5A059] mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            {["About", "Services", "Why Us", "Contact"].map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase().replace(" ", "")}`}
                  data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`}
                  className="hover:text-[#C5A059] transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-6 border-t border-[#2A4436] flex flex-col md:flex-row justify-between gap-3 text-xs text-[#A8B0A9]">
        <div>© {year} Roopesh Kumar & Associates. All rights reserved.</div>
        <div className="italic font-serif text-sm text-[#C5A059]">
          “In numbers we trust; in service, we excel.”
        </div>
      </div>
    </footer>
  );
}
